import React from 'react';
import './Switch.scss';

const Switch = ({ value, onChange, id }) => {

    return (
        <div className='switch'>
            <div className="wrapper">
                <input type="checkbox" className='switch-comp' checked={value} id={id} onChange={() => onChange(!value)}/>
                <label htmlFor={id} className="switch_label">
                    <span className="onf_btn"></span>
                </label>
            </div>
        </div>
    )
}

export default Switch;